import { render, staticRenderFns } from "./MultiFileInput.vue?vue&type=template&id=f38234ec"
import script from "./MultiFileInput.vue?vue&type=script&lang=js"
export * from "./MultiFileInput.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports